// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"016a88d7","369":"f5f9b921","732":"5457bd2c","929":"fb5bba9a","977":"131f07f7","990":"59c77a40"}[chunkId] + ".chunk.js";
};